import React from "react";
import TitleBox from "@/components/TitleBox";
import DropsHighlight from "@/components/DropsHighlight";
import { getUserInfo, callWithAuth } from "@/api/Api";
import { useQuery } from "@tanstack/react-query";
import PlantAnimation from "../PlantAnimation";
import { useDisclosure } from "@chakra-ui/react";
import { GetPlantStatsResponse } from "@shared_types";

interface PlantTreeProps {
  plantStats: GetPlantStatsResponse;
  buttonAction: () => void;
}
const PlantTree: React.FC<PlantTreeProps> = ({ plantStats, buttonAction }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const userInfoQuery = useQuery({
    queryKey: ["userInfo"],
    queryFn: () => {
      return callWithAuth(getUserInfo);
    },
  });
  const firstName = userInfoQuery.data?.firstName || "";

  const handlePlantTree = () => {
    onOpen();
  };

  return (
    <div className="flex flex-col items-center justify-between w-full h-full overflow-hidden gap-5">
      <div className="flex w-full items-center justify-center">
        <TitleBox
          title={`Congrats, ${firstName}! 👏👏👏`}
          subtitle={
            <span className="text-center items-center justify-center">
              You've earned enough water droplets to{" "}
              <span className="font-bold">plant a tree</span>!
            </span>
          }
          classname="text-center items-center justify-center"
        />
      </div>
      <div className="flex flex-col flex-grow items-center justify-center gap-2 w-full h-full">
        <p>🌎 We plant real trees on earth, for you</p>
        <p>💨 Your trees absorb CO2 emissions</p>
        <p>📲 Save your hard earned progress</p>
      </div>
      <div className="w-full py-4">
        <DropsHighlight
          dropsCount={plantStats.waterDropletsCount}
          dropsNeeded={plantStats.waterDropletsNeeded}
          onClick={handlePlantTree}
        />
      </div>
      <PlantAnimation
        isOpen={isOpen}
        buttonAction={buttonAction}
        onClose={onClose}
      />
    </div>
  );
};
export default PlantTree;
